<template>
  <div class="LadderScheme">
    <LadderSchemeItem
      ref="LadderSchemeItem"
      v-for="(item, index) of piecewiseList"
      :key="index + item"
      :length="piecewiseList.length"
      :maxDate="maxDate"
      :amountType="amountType"
      :index="index"
      :item="item"
      :configDisabled="configDisabled"
      :endMonthDisabled="endMonthDisabled"
      @rules="rules"
      @deleteLadderItem="deleteLadderItem"
    />
    <span v-if="showTips" class="tips">{{tips}}</span>
    <div>
      <el-button :disabled="addDisabled || configDisabled" class="button" size="small" @click="addLadder">+ 新增阶梯规则</el-button>
    </div>
  </div>
</template>

<script>
import LadderSchemeItem from './LadderSchemeItem.vue'

export default {
  components: {
    LadderSchemeItem,
  },
  props: {
    piecewiseList: {
      type: Array,
      default: () => [],
    },
    amountType: {
      type: Number,
      default: 1,
    },
    maxDate: {
      type: Number,
      default: 0,
    },
    configDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      endMonthDisabled: false,
      showTips: false,
      tips: '',
    }
  },
  computed: {
    addDisabled() {
      const { length } = this.piecewiseList
      return this.piecewiseList[length - 1].endMonth === '' || Number(this.piecewiseList[length - 1].endMonth) >= this.maxDate || Number(this.piecewiseList[length - 1].endMonth) < Number(this.piecewiseList[length - 1].startMonth)
    },
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    verify() {
      this.$refs.LadderSchemeItem.forEach((item) => {
        item.amountChange()
        item.rules()
      })
    },
    deleteLadderItem(index) {
      // eslint-disable-next-line vue/no-mutating-props
      this.piecewiseList.splice(index, 1)
      this.endMonthDisabled = false
    },
    addLadder() {
      const { length } = this.piecewiseList
      // eslint-disable-next-line vue/no-mutating-props
      this.piecewiseList.push({
        startMonth: Number(this.piecewiseList[length - 1].endMonth) + 1,
        endMonth: this.maxDate === Number(this.piecewiseList[length - 1].endMonth) + 1 ? this.maxDate : '',
        amount: '',
      })
      this.endMonthDisabled = this.maxDate === Number(this.piecewiseList[this.piecewiseList.length - 1].endMonth)
    },
    rules(res, tips) {
      this.showTips = res
      this.tips = tips
    },
  },
}
</script>

<style lang="scss" scoped>
.LadderScheme {
  margin-left: 20px;

  .button {
    width: 237px;
    margin-top: 6px;
    margin-bottom: 20px;
  }

  .tips {
    color: red;
    padding-left: 0px;
  }
}
</style>
